<div *ngIf="isLoading" class="loader-overlay text-xs-center">
  <div class="loader-box">
    <i class="fas fa-cog fa-spin fa-3x"></i>
    <span class="loader-message">{{ message }}</span>
  </div>
</div>
